import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryAspectDraggable extends EventRegistryCategory {
    label = 'Draggable';
    constructor(parent) {
        super(parent);
        super.init();
    }
    draggablestart = () => new EventRegistryItem({
        handlerName: 'onDraggableStart'
    });
    draggabledrag = () => new EventRegistryItem({
        handlerName: 'onDraggableDrag'
    });
    draggableend = () => new EventRegistryItem({
        handlerName: 'onDraggableEnd'
    });
}
